const baseUrl = 'https://www.bakcell.com';

export const generateLocaleUrl = (lang, path) => {
  return `${baseUrl}${lang === 'az' ? '' : `/${lang}`}${path}`;
};
